import React from 'react';
import { Box, Button } from '@material-ui/core';
import { TextField } from 'mui-rff';
import { Form } from 'react-final-form';
import { useIsDesktop, useTranslations } from 'components/utilities';
import { INITIAL_VALUES, validate } from './helpers';
import { changePassword } from 'store/actions';
import { APP_PATHS } from 'components/routes/paths';
import { convertApiFormErrors } from 'helpers';
import { useHistory } from 'react-router-dom';
import { object } from 'prop-types';

const ResetPasswordForm = ({ phoneObject }) => {
	const { t } = useTranslations();
	let history = useHistory();

	const handleSubmit = async (values) => {
		let apiErrors = {};
		values.code = '0000';
		const newValues = { ...phoneObject, ...values };

		try {
			await changePassword(
				newValues,
				(errors) => {
					apiErrors = convertApiFormErrors(errors);
				},
				() => {
					history.push(APP_PATHS.SIGN_IN);
				}
			);
		} catch (error) {
			console.error(error);
		}

		return apiErrors;
	};

	const isDesktop = useIsDesktop();

	const boxPaddings = {
		py: isDesktop ? 12 : 3,
		px: isDesktop ? 12 : 3,
	};

	return (
		<Box {...boxPaddings}>
			<Form
				onSubmit={handleSubmit}
				validate={validate}
				initialValues={INITIAL_VALUES}
			>
				{({ handleSubmit, submitting }) => (
					<form onSubmit={handleSubmit} autoComplete="off">
						<TextField
							autoComplete="new-password"
							variant="outlined"
							label={t('verification.codeLabel')}
							name="code"
							fullWidth
							margin="normal"
							disabled={submitting}
						/>

						<TextField
							type="password"
							autoComplete="new-password"
							variant="outlined"
							label={t('register.password')}
							name="password"
							fullWidth
							margin="normal"
							disabled={submitting}
						/>

						<TextField
							type="password"
							autoComplete="new-password"
							variant="outlined"
							label={t('register.confirmPassword')}
							name="password_confirmation"
							fullWidth
							margin="normal"
							disabled={submitting}
						/>

						<Box pt={isDesktop ? 12 : 4}>
							<Button
								type="submit"
								variant="contained"
								color="primary"
								fullWidth
								size={isDesktop ? 'large' : 'medium'}
								disabled={submitting}
							>
								{t('register.button')}
							</Button>
						</Box>
					</form>
				)}
			</Form>
		</Box>
	);
};

ResetPasswordForm.propTypes = {
	phoneObject: object.isRequired,
};

export default ResetPasswordForm;
